<template>
<div class="course-intro-page">
    <el-form label-width="100px">
        <el-form-item label="标题">
            <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="内容">
            <wedit v-if="flag" v-model="form.paramValue"></wedit>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="publish" :loading="loading">
                发布
            </el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
import wedit from "@/components/wedit/index.vue";
import {
    makeSgin
} from "@/utils/index";

export default {
    data() {
        return {
            loading: false,
            form: {
                remark: undefined,
                paramValue: undefined,
            },
            flag: true,
        };
    },
    components: {
        wedit,
    },
    created() {
        this.getList();
    },
    methods: {
        publish() {
            this.loading = true;
            const target = this.form;
            if (target.id) {
                // 编辑
                this.$http({
                        url: this.$http.adornUrl("sys/config/update"),
                        method: "put",
                        data: this.$http.adornData({
                            paramKey: "MOBILE_HOME",
                            paramValue: target.paramValue,
                            id: target.id,
                            remark: target.remark,
                        }),
                    })
                    .then(({
                        data
                    }) => {
                        if (data.code === 0) {
                            this.$message({
                                message: "发布成功",
                                type: "success",
                            });
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                // 新增
                this.$http({
                        url: this.$http.adornUrl("sys/config/save"),
                        method: "post",
                        data: this.$http.adornData({
                            paramKey: "MOBILE_HOME",
                            paramValue: target.paramValue,
                            remark: target.remark,
                        }),
                    })
                    .then(({
                        data
                    }) => {
                        // console.log(res)
                        if (data.code === 0) {
                            this.$message({
                                message: "发布成功",
                                type: "success",
                                duration: 1500,
                            });
                            this.getList();
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },
        getList() {
            this.flag = false;
            this.$http({
                    url: this.$http.adornUrl("common/mobileHome?sign=" + makeSgin()),
                    method: "get",
                })
                .then(({
                    data
                }) => {
                    if (data.code === 0) {
                        this.form = data.data;
                    } else {
                        this.$message.error("获取失败");
                    }
                })
                .catch(() => {
                    this.$message.error("获取失败");
                })
                .finally(() => {
                    this.flag = true;
                });
        },
    },
};
</script>

<style lang="scss">
.course-intro-page {
    position: relative;

    .add-button {
        position: absolute;
        right: 10px;
        top: 6px;
        z-index: 9;
    }
}
</style>
